/* @ngInject */
export default function UserLogService($q, $sails, $log) {
  const service = this;

  service.getUserLog = getUserLog;
  service.updateEntry = updateEntry;

  function getUserLog(userId, startDate, endDate, page, count, sorting, filter) {
    return $sails.get(`/userlog/${userId}?startDate=${startDate}&endDate=${endDate
    }&page=${page}&sort=${sorting}&count=${count}&filter=${filter}`)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function updateEntry(entryId, updatedEntryFields) {
    return $sails.put(`/userlog/${entryId}`, updatedEntryFields)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }
}

